(ns journal-app-client.utils.react
  (:require ["react" :as react]
            ["@formkit/auto-animate/react" :refer [useAutoAnimate]]))

(def use-state react/useState)
(def use-effect react/useEffect)
(def use-ref react/useRef)
(def use-callback react/useCallback)
(def create-context react/createContext)
(def use-context react/useContext)
(def use-memo react/useMemo)

(def use-auto-animate useAutoAnimate)